import { StudioShapeDescriptor } from '..';
import { StudioSceneShape } from '../../../shape/shapes/general/root/studio-scene-shape';
import {
  GradientDirection,
  RectangleElement,
} from '../../../shape/shapes/primitive/rectangle-element';
import { StudioShape } from '../shapes/studio-shape';

export interface StudioElementShapeDescriptor extends StudioShapeDescriptor {
  shapes: string[];
  type: 'rectangle' | 'circle' | 'path';
  radius?: number;
  fill?: {
    color: string;
    opacity?: number;
    gradient?: {
      type: 'linear' | 'radial';
      direction?: GradientDirection;
      colors?: string[];
      stops?: number[];
    };
  };
  margin?: number;
  stroke?: {
    color: string;
    width: number;
  };
}

export class StudioElementShape extends StudioShape<StudioElementShapeDescriptor> {
  rectangleElement: RectangleElement;

  getType() {
    return 'element-shape';
  }
  constructor(
    shape: StudioSceneShape,
    id: string,
    descriptor: StudioElementShapeDescriptor,
  ) {
    super(shape, id, descriptor);
    this.initRectangleElement();
  }

  update(descriptor: StudioElementShapeDescriptor) {
    this.descriptor = descriptor;
    this.rectangleElement?.remove();
    this.initRectangleElement();
    this.initBackgroundElement(this.descriptor.cell.background);
  }

  initRectangleElement(): RectangleElement {
    return;
    const [width, height] = this.netDims;
    const { radius, fill, stroke, margin } = this.descriptor;

    const marginOffset =
      (margin || 0) *
      (this.cs.isPortrait ? this.cs.currentScreenY : this.cs.currentScreenX);
    const { x, y, w, h } = this.cellDims;
    if (fill?.gradient) {
      const gradientStops =
        fill.gradient.colors?.map((color, index) => ({
          color,
          stop: fill.gradient.stops?.[index],
        })) || [];

      this.rectangleElement = new RectangleElement(this, this.container, {
        position: { x: x + marginOffset, y: y + marginOffset },
        width: w - 2 * marginOffset,
        height: h - 2 * marginOffset,
        gradient: true,
        gradientDirection: fill.gradient.direction,
        gradientStops,
        r: radius || 0,
        'fill-opacity': fill.opacity,
        stroke: stroke?.color,
        'stroke-width': stroke?.width,
      });
    } else {
      this.rectangleElement = new RectangleElement(this, this.container, {
        position: { x: x + marginOffset, y: y + marginOffset },
        width: w - 2 * marginOffset,
        height: h - 2 * marginOffset,
        r: radius || 0,
        fill: fill?.color,
        'fill-opacity': fill?.opacity,
        stroke: stroke?.color,
        'stroke-width': stroke?.width,
      });
    }

    return this.rectangleElement;
  }
}
